import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MarkdownService} from '@q9elements/ui-kit/common';

@Pipe({
  name: 'textToHtml',
  standalone: true
})
export class TextToHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private markedService: MarkdownService
  ) {}

  transform(value = ''): string {
    if (!value) {
      return '';
    }

    if (value.endsWith('-')) {
      value = value.slice(0, -1);
    }

    const html = this.markedService.markdownToHtml(value);

    return this.sanitizer.bypassSecurityTrustHtml(html) as string;
  }
}
